import { Injectable } from '@angular/core';

import { GraphEndpoint } from '@camelot/server';

import { CamQuotationGridService } from './quotation-grid.service';

const graphEndpoint: GraphEndpoint = {
  clientName: 'quotationGridVisitorService',
  endpoint: 'quotation',
};

@Injectable({
  providedIn: 'root',
})
export class CamQuotationGridVisitorService extends CamQuotationGridService {
  protected override _graphEndpoint = graphEndpoint;

  constructor() {
    super();

    super.registerRoutes({ graphEndpoint });
  }
}
